// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__3BL5j","inputWrap":"styles_inputWrap__2b5Yg","input":"styles_input__CmA0U"};